(() => {
  if (window.__vhVanityModalController) return;
  window.__vhVanityModalController = true;

  const setLocked = (locked) => {
    document.documentElement.classList.toggle('vh-vanity-modal-is-open', locked);
    document.body.classList.toggle('vh-vanity-modal-is-open', locked);
  };

  const openModal = (button) => {
    const picker = button.closest('.vh-vanity-picker');
    const modal = picker?.querySelector('[data-vh-vanity-modal]');
    if (!modal) return;

    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', 'open');
    }
    setLocked(true);
  };

  const closeModal = (modal) => {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) modal.close();
    else modal.removeAttribute('open');
    setLocked(Boolean(document.querySelector('[data-vh-vanity-modal][open]')));
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-vh-vanity-modal-open]');
    if (openButton) {
      event.preventDefault();
      openModal(openButton);
      return;
    }

    const closeButton = event.target.closest('[data-vh-vanity-modal-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('[data-vh-vanity-modal]'));
      return;
    }

    const modal = event.target.closest('[data-vh-vanity-modal]');
    if (modal && event.target === modal) closeModal(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vh-vanity-modal][open]').forEach(closeModal);
  });
})();
